import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { Row, Button } from 'reactstrap'
import { DefaultState } from '../../types'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'
import ManualUploadsDevForm from './ManualUploadsDevForm'
import ManualUploadsUserForm from './ManualUploadsUserForm'


const ManualUploadsBody = () => {
  const manualUploads = useSelector(
    (state: DefaultState) => state.manualUploads
  )
  const userData = useSelector((state: DefaultState) => state.session.data.user)
  const isAdmin = userData?.roles?.includes('admin') ? true : false

  if (manualUploads.error) {
    return (
      <div style={{ maxWidth: '800px' }}>
        <ICSErrorCard
          code={manualUploads.error ? manualUploads.error.code : 'error'}
          message={manualUploads.error ? manualUploads.error.message : ''}
          fields={manualUploads.error ? manualUploads.error.fields : []}
        />
        <Row
          style={{ margin: '.75rem auto', width: '98%' }}
          className='manual-uploads-row button-row'
        >
           <Button
            onClick={() => window.location.reload()}
            id='manual_uploads_form_submit'
            style={{
              backgroundColor: '#337ab7',
              color: '#fff',
              fontFamily: 'Helvetica Neue helvetica, verdana, sans-serif',
              fontSize: '14px'
            }}
          >
            Reload
          </Button>
          <Button
            onClick={() => history.back()}
            id='manual_uploads_form_submit'
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              fontFamily: 'Helvetica Neue helvetica, verdana, sans-serif',
              fontSize: '14px'
            }}
          >
            Back
          </Button>
        </Row>
      </div>
    )
  } else if (manualUploads.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <LoadIndicator />
      </div>
    )
  } else {
    return (
      <>
        {/* {(!isAdmin ||  isUser) && <ManualUploadsUserForm />} */}
        {!isAdmin &&<ManualUploadsUserForm />}
        {isAdmin && <ManualUploadsDevForm />}
      </>
    )
  }
}

export default ManualUploadsBody
